import {BasicConstants} from "../constants/BasicConstants";


// TODO @HTML5 this regex reflex the folder structure of the flash games.  html5 dont have yet feature branches and their filetestserver have different folder structure  -->  NOT /web/feature_branch01/beta/games/empire/  BUT /web/empire_html5/client  therefore i'd guess we should adjust it later on
const featureBranchRegExp: RegExp = new RegExp(
    "http?s?:\/\/(" + BasicConstants.DOMAIN_INTERNAL_DNS + "|" + BasicConstants.DOMAIN_INTERNAL_DNS_ALIAS + ")\/web\/([a-zA-Z0-9_\/]+)\/(release|beta)\/"
);
export const detectFeatureBranchEnvironment = (url: string): {isFeatureBranch: boolean, id: string, environment: string} => {


    let isFeatureBranch: boolean = false;
    let id: string;
    let environment: string;
    if (url) {
        let featureBranchArray: string[] = url.match(featureBranchRegExp);

        if (featureBranchArray) {
            isFeatureBranch = true;
            //domain = featureBranchArray[1]
            id = featureBranchArray[2];
            environment = featureBranchArray[3]
        }
    }

    return {isFeatureBranch, id, environment};
};
